





import { Vue, Component, ModelSync } from 'vue-property-decorator';
@Component
export default class KTag extends Vue {
  @ModelSync('tag', 'change', { type: String })
  tags!: string;

  get tagArr(): string[] {
    return this.tags?this.tags.split(','):[];
  }

  set tagArr(value: string[]) {
    this.$emit('change', value.join(','));
  }
}
